import {
    LEADER_BOARD_GET_SETTINGS_SUCCESS,
    LEADER_BOARD_PUT_SETTINGS_SUCCESS,
    LEADER_BOARD_SETTINGS_QUIZ_SUCCESS
} from './constants';

let laederBoardState = {};
let laederBoardQuiz = [];
/**
 *
 * @param state
 * @param action
 * @returns {{}}
 */
const leaderBoardSettings = ( state = laederBoardState, action ) => {
    switch ( action.type ) {
        case LEADER_BOARD_PUT_SETTINGS_SUCCESS:
        case LEADER_BOARD_GET_SETTINGS_SUCCESS : {
            laederBoardState = { ...action.result };
            return laederBoardState;
        }
        default:
            return state;
    }
};
/**
 *
 * @param state
 * @param action
 * @returns {[]}
 */
const leaderBoardQuizList = ( state = laederBoardQuiz, action ) => {
    switch ( action.type ) {
        case LEADER_BOARD_SETTINGS_QUIZ_SUCCESS : {
            laederBoardQuiz = [ ...action.result ];
            return laederBoardQuiz;
        }
        default:
            return state;
    }
};

export { leaderBoardSettings, leaderBoardQuizList };